<template>
    {{ text }}
    <a-tooltip v-if="detailsText.length > 0" trigger="click" placement="bottom">
        <template #title>
            <span>{{ detailsText }}</span>
        </template>
        <span class="more-details">
            more details
        </span>
    </a-tooltip>
</template>

<script>

export default {
    props: {
        notification: {
            type: Object,
            required: true
        }
    },

    computed: {
        text() {
            return this.splitText[0];
        },

        detailsText() {
            return this.splitText[1];
        },

        splitText() {
            let firstPartText = '';
            let secondPartText = '';

            this.notification.text.split('. ').forEach(partText => {
                if (firstPartText.length < 100) {
                    firstPartText += partText + '. ';
                } else {
                    secondPartText += partText + '. ';
                }
            });

            return [firstPartText, secondPartText];
        }
    }
};
</script>

<style lang="scss" scoped>
.more-details {
    cursor: pointer;
    color: #73818C;
    text-decoration: underline;
}
</style>
